import React from "react";
import "./about.scss";
import { FaEnvelope, FaFootballBall, FaGamepad, FaHeart, FaPhoneAlt, FaUser, FaViadeo } from "react-icons/fa";

const About = () => {
  return (
    <div className="about-section" id="about">
      <div className="center">
        <ul className="comps flex">
          <li className="flex">
            <h3 className="flex">
              <FaHeart />
            </h3>
            <div className="comp">
              <h2>9+ Years</h2>
              <h5>Experience</h5>
            </div>
          </li>
          <li className="flex">
            <h3 className="flex">
              <FaHeart />
            </h3>
            <div className="comp">
              <h2>300+ projects</h2>
              <h5>Completed</h5>
            </div>
          </li>
          <li className="flex">
            <h3 className="flex">
              <FaHeart />
            </h3>
            <div className="comp">
              <h2>Availability</h2>
              <h5>Online 24/7</h5>
            </div>
          </li>
        </ul>
      </div>
      <div className="bottom flex">
        <div className="left">
          <div className="class"></div>
        </div>
        <div className="right">
          <span>Who I am</span>
          <h1>About me</h1>
          <p>
            I am a Frontend/Fullstack/UI/UX/Web & Graphic designer from Uganda
            with over 9 years experience in MYSQL EXPRESS REACT NODEJS(MERN)
            stack, Wordpress, ASP.NET, Magento,FileMaker Pro, and design tools
            like Figma,Adobe Illustrator, Photoshop, Indesign etc{" "}
          </p>
          <div className="grid-items">
            <li>
              <h3>
                <span>
                  <FaUser />
                </span>
                Names
              </h3>
              <h3>:</h3>
              <h3>Ssekitto Shafiq</h3>
            </li>
            <li>
              <h3>
                <span>
                  <FaPhoneAlt />
                </span>{" "}
                Phone
              </h3>
              <h3>:</h3>
              <h3>+256 773 516 684</h3>
            </li>
            <li>
              <h3>
                <span>
                  <FaEnvelope />
                </span>
                Email
              </h3>
              <h3>:</h3>
              <h3>ssekittoshafiq@gmail.com</h3>
            </li>
          </div>
          <div className="interest">
            <h2>My Interests</h2>
            <div className="int flex">
              <h3>
                <span>
                  <FaFootballBall />
                </span>
                Soccer
              </h3>
              <h3>
                <span>
                  <FaViadeo />
                </span>
                Movies
              </h3>
              <h3>
                <span>
                  <FaGamepad />
                </span>
                Games
              </h3>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default About;
